<template>
  <div class="fill-height d-flex flex-column" style="overflow-x: hidden">

    <div v-if="loadingSites" class="d-flex align-center justify-center fill-height flex-grow-1">
      <app-centre-loader label="Loading Sites"></app-centre-loader>
    </div>

    <v-scroll-x-transition hide-on-leave>
      <div v-if="!loadingSites" class="fill-height of-y">
        <div v-if="!sites.length" class="fill-height d-flex align-center justify-center overline amber--text">
          No Data For Given Range
        </div>
        <div v-else class="fill-height of-y">
          <v-data-table
            ref="table"
            :headers="viewColumns"
            :items="sites"
            :items-per-page="sites.length"
            class="fill-height of-y full-table ft-first-col text-caption"
            hide-default-footer
            fixed-header
            item-key="_id"
            style="width: 2048px; overflow-x: auto"
            dense
          >

            <template #item.billingPlan="{item}">
              <div style="overflow: hidden" class="table-item-no-overflow">
                <v-autocomplete
                  :hide-details="true"
                  :items="['STARTER', 'PRO PLUS', 'PRO']"
                  dense
                  style="width: 150px"
                  :disabled="loadingKeys.includes(`${item._id}-billingPlan`)"
                  :loading="loadingKeys.includes(`${item._id}-billingPlan`)"
                  color="primary"
                  flat
                  class="py-0 my-0"
                  v-model="item.billingPlan"
                  @change="ev => updateBillingPlan(item, ev)"
                ></v-autocomplete>
              </div>
            </template>

            <template #item.address="{item}">
              <span v-if="item.address.line1" class="text-caption">{{item.address.line1}}</span>
              <span v-if="item.address.line2" class="text-caption">{{item.address.line2}}</span>
              <br>
              <span v-if="item.address.region" class="text-caption">{{item.address.region}}</span>
              <span v-if="item.address.city" class="text-caption">{{item.address.city}}</span>
              <span v-if="item.address.areaCode" class="text-caption">{{item.address.areaCode}}</span>
            </template>

            <template #item.trialExpire="{item}">
              {{ format(new Date(item.trialExpire), 'yyyy-MM-dd') }}
            </template>

            <template #item.createdAt="{item}">
              {{ format(new Date(item.createdAt), 'yyyy-MM-dd') }}
            </template>

            <template #item.disabled="{item}">
              <v-btn
                color="primary"
                :loading="loadingKeys.includes(`${item._id}-disabled`)"
                :disabled="loadingKeys.includes(`${item._id}-disabled`)"
                @click="disableSite(item)"
                text
                icon
              >
                <v-icon>{{item.disabled ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}</v-icon>
              </v-btn>

            </template>


            <template #item.autoAiClassifications="{item}">
              <v-tooltip top>
                <template #activator="{on}">
                  <v-btn
                    v-on="on"
                    text
                    icon
                    :color="item.companyDescription.value ? 'blue' : 'grey'"
                    @click="viewCompanyDescription = item"
                  >
                    <v-icon>mdi-lightbulb-auto-outline</v-icon>
                  </v-btn>
                </template>
                {{ item.companyDescription.value ? "Edit" : "Set" }}&nbsp;Company Description
              </v-tooltip>
            </template>

            <!--                        <template #item.lastSnapshot="{item}">-->
            <!--                            {{item.lastSnapshot ? item.lastSnapshot.runKey : null}}-->
            <!--                        </template>-->

            <template #item.releaseTrack.app="{item}">
              <div style="overflow: hidden" class="table-item-no-overflow">
                <v-autocomplete
                  :hide-details="true"
                  :items="appVersions"
                  dense
                  style="width: 100px"
                  :disabled="loadingKeys.includes(`${item._id}-releaseTrack`)"
                  :loading="loadingKeys.includes(`${item._id}-releaseTrack`)"
                  color="primary"
                  flat
                  class="py-0 my-0"
                  v-model="item.releaseTrack.app"
                  @change="ev => updateRelease(item, 'app', ev)"
                  chips
                  small-chips
                ></v-autocomplete>
              </div>
            </template>

            <template #item.releaseTrack.launcher="{item}">
              <div style="overflow: hidden" class="table-item-no-overflow">
                <v-autocomplete
                  :hide-details="true"
                  :items="launcherVersions"
                  dense
                  style="width: 100px"
                  :disabled="loadingKeys.includes(`${item._id}-releaseTrack`)"
                  :loading="loadingKeys.includes(`${item._id}-releaseTrack`)"
                  color="primary"
                  flat
                  class="py-0 my-0"
                  v-model="item.releaseTrack.launcher"
                  @change="ev => updateRelease(item, 'launcher', ev)"
                  chips
                  small-chips
                ></v-autocomplete>
              </div>
            </template>

            <template #item.releaseTrack.updater="{item}">
              <div style="overflow: hidden" class="table-item-no-overflow">
                <v-autocomplete
                  :hide-details="true"
                  :items="updaterVersions"
                  dense
                  style="width: 100px"
                  :disabled="loadingKeys.includes(`${item._id}-releaseTrack`)"
                  :loading="loadingKeys.includes(`${item._id}-releaseTrack`)"
                  color="primary"
                  flat
                  class="py-0 my-0"
                  v-model="item.releaseTrack.updater"
                  @change="ev => updateRelease(item, 'updater', ev)"
                  chips
                  small-chips
                ></v-autocomplete>
              </div>
            </template>


            <template #item.users="{item}">
              <v-btn
                color="primary"
                @click="viewUsers = item"
                small
                text
              >View Users</v-btn>
            </template>

            <template #item.manualTimeBreakInterval="{item}">
              <v-btn
                text
                small
                color="primary"
                @click="viewManualTimeBreakInterval = item"
              >Set Interval ({{ item.manualTimeBreakInterval.value }})</v-btn>
            </template>

            <template #item.employees="{item}">
              <v-btn
                color="primary"
                @click="$refs.snapshotExplorer.previewSnapshot(item.lastSnapshot)"
                small
                text
                :disabled="!item.employees"
              >{{ item.employees }}</v-btn>
            </template>

            <!--                        @click:row="gotoAppStats($event.appName)"-->
            <!--                        <template v-slot:item.appName="{ item }">-->
            <!--                            <div class="d-flex align-center overline" style="white-space: nowrap">-->
            <!--                                <app-icon :key="item._id + item.appName" :match="item.appName" left small/>-->
            <!--                                {{ item.appName }}-->
            <!--                            </div>-->
            <!--                        </template>-->
            <!--                        -->
            <!--                        &lt;!&ndash;label&ndash;&gt;-->
            <!--                        <template v-slot:item.label="{ item }">-->
            <!--                            <div class="d-flex align-center overline" :class="`${labelsRef[item.label].color}&#45;&#45;text`">-->
            <!--                                <v-icon small :color="labelsRef[item.label].color" left>{{labelsRef[item.label].icon}}</v-icon>-->
            <!--                                {{labelsRef[item.label].text}}-->
            <!--                            </div>-->
            <!--                        </template>-->
            <!--                        -->
            <!--                        <template v-slot:item.tt="{ item }">{{ hoursDisplay(item.tt, true) }}</template>-->
            <!--                        <template v-slot:item.ttn="{ item }">{{ hoursDisplay(item.ttn, true) }}</template>-->
            <!--                        <template v-slot:item.tto="{ item }">{{ hoursDisplay(item.tto, true) }}</template>-->
            <!--                        -->
            <!--                        &lt;!&ndash;count&ndash;&gt;-->
            <!--                        -->
            <!--                        -->
            <!--                        <template v-slot:item.actions="{ item }">-->
            <!--                            <v-btn-->
            <!--                                color="primary"-->
            <!--                                class="mx-2"-->
            <!--                                small-->
            <!--                                icon-->
            <!--                                :loading="loadingClassifications.includes(item.appName)"-->
            <!--                                @click.stop="classificationMenuClicked($event, item)"-->
            <!--                            >-->
            <!--                                <v-icon>mdi-cog</v-icon>-->
            <!--                            </v-btn>-->
            <!--                        </template>-->

          </v-data-table>
        </div>
      </div>
    </v-scroll-x-transition>

    <app-dlg
      v-if="viewUsers"
      :show-dlg="!!viewUsers"
      @update-show-dlg="viewUsers = null"
      :title="viewUsers.name"
      :default-padding="false"
      :dlg-width="500"
    >

      <app-list
        :items="viewUsers.users"
        headline-key="name"
        sub-line-key="username"
        item-key="_id"
        :show-check-boxes="false"
        :return-object="true"
        class="fill-height of-y"
        :height="450"
        @input="userClicked"
      />

      <template v-slot:actions>
        <v-btn
          @click="viewUsers = null"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
        >
          Done
        </v-btn>
      </template>
    </app-dlg> <!-- View Users -->

    <app-dlg
      v-if="viewManualTimeBreakInterval"
      :show-dlg="!!viewManualTimeBreakInterval"
      @update-show-dlg="viewManualTimeBreakInterval = null"
      title="Set Manual Time Break Interval"
      :default-padding="false"
      :dlg-width="360"
    >

      <v-form
        ref="updateManualTimeBreakInterval"
        @submit="$event.preventDefault()"
        class="d-flex justify-center align-center py-3"
      >
        <v-text-field
          dense
          outlined
          color="primary"
          prepend-inner-icon="mdi-timer-sand"
          label="Set Manual Time Break Interval (Seconds)"
          placeholder="Set Manual Time Break Interval"
          class="pa-0 ma-0"
          style="max-width: 90%"
          v-model="updateManualTimeBreakInterval.manualTimeBreakInterval.value"
          :rules="[validationRules.wholeNumberOnly]"
        ></v-text-field>
      </v-form>

      <template v-slot:actions>
        <v-btn
          small
          class="ml-2"
          size="small"
          color="secondary"
          variant="contained"
          :loading="loadingManualTimeBreakIntervalUpdate"
          :disabled="loadingManualTimeBreakIntervalUpdate"
          @click="updateManualTimeInterval"
        >Save</v-btn>
        <v-btn
          small
          class="ml-2"
          size="small"
          color="error"
          variant="contained"
          :loading="loadingManualTimeBreakIntervalUpdate"
          :disabled="loadingManualTimeBreakIntervalUpdate"
          @click="viewManualTimeBreakInterval = null"
        >Cancel</v-btn>
      </template>
    </app-dlg> <!-- Set manual Time Break Interval -->

    <app-dlg
      v-if="viewCompanyDescription"
      :show-dlg="!!viewCompanyDescription"
      @update-show-dlg="viewCompanyDescription = null"
      title="Set company description"
      :default-padding="false"
      :dlg-width="500"
    >

      <v-form
        ref="updateCompanyDescription"
        @submit="$event.preventDefault()"
        class="d-flex justify-center align-center py-3"
      >
        <v-textarea
          dense
          outlined
          rows="3"
          auto-grow
          color="primary"
          prepend-inner-icon="mdi-timer-sand"
          label="Set Company Description"
          placeholder="Set Company Description"
          class="pa-0 ma-0"
          style="max-width: 90%"
          v-model="companyDescription.companyDescription.value"
        ></v-textarea>
<!--        v-model="updateManualTimeBreakInterval.manualTimeBreakInterval.value"-->
      </v-form>

      <template v-slot:actions>
        <v-btn
          small
          class="ml-2"
          size="small"
          color="blue"
          variant="contained"
          :loading="loadingCompanyDescriptionUpdate"
          :disabled="loadingCompanyDescriptionUpdate || !companyDescription.companyDescription.value"
          @click="updateCompanyDescription(true)"
        >Reset</v-btn>
        <v-btn
          small
          class="ml-2"
          size="small"
          color="secondary"
          variant="contained"
          :loading="loadingCompanyDescriptionUpdate"
          :disabled="loadingCompanyDescriptionUpdate"
          @click="updateCompanyDescription(false)"
        >Save</v-btn>
        <v-btn
          small
          class="ml-2"
          size="small"
          color="error"
          variant="contained"
          :loading="loadingCompanyDescriptionUpdate"
          :disabled="loadingCompanyDescriptionUpdate"
          @click="viewCompanyDescription = null"
        >Cancel</v-btn>
      </template>
    </app-dlg> <!-- Set Company Description -->

    <app-employee-snapshot-explorer ref="snapshotExplorer"></app-employee-snapshot-explorer>
  </div>
</template>

<script>

import {arrSplice, copyText, nameSort, validationRules} from "@/core/codeFunctions";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import AppPartnerSiteSideBar from "@/components/Partner/AppPartnerSiteSideBar";
import {format} from "date-fns";
import AppList from "@/components/Shared/AppList/AppList.vue";
import AppDlg from "@/components/Shared/AppDlg.vue";
import AppEmployeeSnapshotExplorer from "@/components/Shared/EmployeeSnapshotExplorer/AppEmployeeSnapshotExplorer";

export default {
  components: {
    AppDlg,
    AppList,
    AppPartnerSiteSideBar,
    AppCentreLoader,
    AppEmployeeSnapshotExplorer
  },
  data() {
    return {
      format,
      console,

      loadingSites: false,
      sites: [],
      selectedSite: null,
      updaterVersions: [],
      launcherVersions: [],
      appVersions: [],
      viewColumns: [
        {text: "Name", value: "name"},
        {text: "Plan", value: "billingPlan"},
        // {text: "Address", value: "address"},
        {text: "Contact No", value: "contactNumber"},
        // {text: "Trial Exp", value: "trialExpire"},
        {text: "Disabled", value: "disabled", align: "center"},

        {text: "Auto AI Classifications", value: "autoAiClassifications", align: 'center'},

        {text: "Created", value: "createdAt"},
        {text: "Last Snapshot", value: "lastSnapshot.runKey"},
        {text: "Employees", value: "employees"},
        {text: "App", value: "releaseTrack.app"},
        {text: "Launcher", value: "releaseTrack.launcher"},
        {text: "Updater", value: "releaseTrack.updater"},
        {text: "Manual Time Break Interval", value: "manualTimeBreakInterval"},
        {text: "Users", value: "users"},

        // {
        //     text: string,
        //     value: string,
        //     align?: 'start' | 'center' | 'end',
        //     sortable?: boolean,
        //     filterable?: boolean,
        //     groupable?: boolean,
        //     divider?: boolean,
        //     class?: string | string[],
        //     cellClass?: string | string[],
        //     width?: string | number,
        //     filter?: (value: any, search: string, item: any) => boolean,
        //     sort?: (a: any, b: any) => number
        // }
      ],
      loadingKeys: [],
      viewUsers: null,
      viewManualTimeBreakInterval: null,
      updateManualTimeBreakInterval: null,
      loadingManualTimeBreakIntervalUpdate: false,

      viewCompanyDescription: null,
      companyDescription: null,
      loadingCompanyDescriptionUpdate: false,

      validationRules: validationRules
    }
  },
  watch: {
    viewManualTimeBreakInterval: {
      immediate: false,
      deep: true,
      handler(newVal) {
        this.updateManualTimeBreakInterval = JSON.parse(JSON.stringify(newVal));
      }
    },
    viewCompanyDescription: {
      immediate: false,
      deep: true,
      handler(newVal) {
        this.companyDescription = JSON.parse(JSON.stringify(newVal));
      }
    }
  },
  created() {},
  beforeUnmount() {},
  mounted() {
    this.loadPartnerSites();
  },
  methods: {
    async loadPartnerSites() {
      try {
        this.loadingSites = true;

        const {
          updaterVersions,
          launcherVersions,
          appVersions,
          sites
        } = await this.$newReq('GET', `partner/sites/manage/startup`)

        this.updaterVersions = updaterVersions;
        this.launcherVersions = launcherVersions;
        this.appVersions = appVersions;
        this.sites = sites.map(site => {
          if (!site.billingPlan)
            site.billingPlan = null

          if (!site.releaseTrack)
            site.releaseTrack = {}

          site.releaseTrack.app = site.releaseTrack.app || null
          site.releaseTrack.launcher = site.releaseTrack.launcher || null
          site.releaseTrack.updater = site.releaseTrack.updater || null


          if (!site.lastSnapshot)
            site.lastSnapshot = {}

          site.lastSnapshot.runKey = site.lastSnapshot.runKey || null

          if (site.lastSnapshot.snapshot) {
            site.employees = site.lastSnapshot.snapshot.length
          } else {
            site.employees = null
          }

          return site
        })
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
      } finally {
        this.loadingSites = false
      }

    },

    async disableSite(site) {
      const loadingKey = `${site._id}-disabled`
      try {
        this.loadingKeys.push(loadingKey);
        const updated = await this.$newReq('POST', `partner/sites/manage/disabled`, {
          siteId: site._id,
          value: !site.disabled
        })

        if (updated.success)
          site.disabled = !site.disabled
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
      } finally {
        this.loadingSites = false
        arrSplice(this.loadingKeys, val => val === loadingKey);
      }
    },

    async updateBillingPlan(site, plan) {
      const loadingKey = `${site._id}-billingPlan`
      const preValue = site.billingPlan
      try {
        this.loadingKeys.push(loadingKey);
        const updated = await this.$newReq('POST', `partner/sites/manage/billingPlan`, {
          siteId: site._id,
          value: plan
        })
        if (updated.success)
          site.billingPlan = plan
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
        site.billingPlan = preValue
      } finally {
        this.loadingSites = false
        arrSplice(this.loadingKeys, val => val === loadingKey);
      }
    },

    async updateRelease(site, key, version) {
      const loadingKey = `${site._id}-releaseTrack`
      const preValue = {...site.releaseTrack}

      const newTrack = {...preValue}

      newTrack[key] = version

      try {
        this.loadingKeys.push(loadingKey);
        const updated = await this.$newReq('POST', `partner/sites/manage/releaseTrack`, {
          siteId: site._id,
          value: newTrack
        })
        if (updated.success)
          site.releaseTrack = newTrack
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
        site.releaseTrack = preValue
      } finally {
        this.loadingSites = false
        arrSplice(this.loadingKeys, val => val === loadingKey);
      }
    },

    async updateManualTimeInterval() {
      if (!this.$refs.updateManualTimeBreakInterval.validate())
        return this.$snack("Only whole numbers allowed");

      this.loadingManualTimeBreakIntervalUpdate = true;

      try {
        this.updateManualTimeBreakInterval.manualTimeBreakInterval.value = parseInt(this.updateManualTimeBreakInterval.manualTimeBreakInterval.value);

        this.viewManualTimeBreakInterval.manualTimeBreakInterval = await this.$newReq(
          'POST',
          `partner/sites/manage/manualTimeInterval`,
          this.updateManualTimeBreakInterval
        );

        this.viewManualTimeBreakInterval = null;
        this.$snack.info('Manual Time Break Interval Updated Successfully');
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
      } finally {
        this.loadingManualTimeBreakIntervalUpdate = false;
      }
    },

    async updateCompanyDescription(reset = false) {

      console.log('reset', reset);

      if (reset)
        this.companyDescription.companyDescription.value = null;


      this.loadingCompanyDescriptionUpdate = true;

      try {
        this.viewCompanyDescription.companyDescription = await this.$newReq(
          'POST',
          `partner/sites/manage/companyDescription`,
          this.companyDescription
        );

        this.viewCompanyDescription = null;
        this.$snack.info('Company Description Updated Successfully');
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
      } finally {
        this.loadingCompanyDescriptionUpdate = false;
      }
    },

    userClicked([user]) {
      console.log(user)
      copyText(document, user.username)
      this.$snack.info('Username copied to clipboard')
    },

    setSnapshot(site) {}
  },


  computed: {
    filterStr() {
      return this.$store.state.ref.partner.sites.filterStr;
    },

    filteredSites() {
      return (this.sites || [])
        .filter(site => this.filterStr ? JSON.stringify(site).toLowerCase().includes((this.filterStr || '').toLowerCase()) : true)
        .sort(nameSort)
    }

  },
}
</script>

<style>
.table-item-no-overflow div {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.table-item-overflow div {
  overflow-y: auto !important;
  overflow-x: auto !important;
}


</style>